import { createPortal } from 'react-dom'

import { Button } from '@/Atomic/Molecules/Button'

import './ConfirmActionModal.scss'

interface ConfirmActionModalProps {
  isOpen: boolean
  title: string
  message: string
  confirmText: string
  cancelText: string
  variant?: 'danger' | 'primary'
  onConfirm: () => void
  onClose: () => void
}

export const ConfirmActionModal = ({
  isOpen,
  title,
  message,
  confirmText,
  cancelText,
  variant = 'danger',
  onConfirm,
  onClose,
}: ConfirmActionModalProps) => {
  if (!isOpen) return null

  return createPortal(
    <>
      <div className="confirm-action-backdrop" onClick={onClose} />
      <div
        className="confirm-action-modal"
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <div className="confirm-action-title">{title}</div>
        <div className="confirm-action-message">{message}</div>
        <div className="confirm-action-footer">
          <Button variant="outlined" onClick={onClose}>
            {cancelText}
          </Button>
          <Button variant={variant} onClick={onConfirm}>
            {confirmText}
          </Button>
        </div>
      </div>
    </>,
    document.body,
  )
}
